import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import asModal from '../../../../components/as-modal';
import style from './provider-settings-modal.module.less';
import GetProviderDisplayName from '../../../../components/data-driven-logo/get-provider-display-name';
import ModalPortal from '../../../../components/modal-portal';
import { useEnableDirectModeCarriers } from '../../../../feature-flags/hooks/use-enable-direct-mode-carriers';
import { LabelProviderSettings } from '../../../../connection-components/label-provider-settings';

const ProviderSettings = ({ onClose, onConfirmed, provider, onUpdateSellerData }) => {
  const isDirectMode = useEnableDirectModeCarriers();

  const onError = useCallback((error) => {
    alert(error.message);
  }, []);

  return (
    <ModalPortal containerId='provider-settings-modal' onClose={onClose}>
      <Modal className={classnames(style['provider-settings-modal'])}>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage
            defaultMessage='Configure your {providerName} Account'
            description='src.pages.settings.providers.provider-settings-modal.title'
            id='dgesDR'
            values={{
              providerName: <FormattedMessage {...GetProviderDisplayName(provider.labelProviderId)} />,
            }}
          />
        </ModalHeader>
        <ModalBody
          className={classnames(style['modal-body'], { [style['iframe-mode']]: !isDirectMode })}
          shouldIgnoreRootFocus={isDirectMode}
        >
          <LabelProviderSettings
            onCancel={onClose}
            onError={onError}
            onSave={onConfirmed}
            onUpdateSellerData={onUpdateSellerData}
            sellerLabelProviderId={`${provider.sellerLabelProviderId}`}
          />
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};

ProviderSettings.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirmed: PropTypes.func.isRequired,
  onUpdateSellerData: PropTypes.func.isRequired,
  provider: PropTypes.object.isRequired,
};

export const ProviderSettingsModal = asModal(ProviderSettings);
